const SkeletonLine = ({ size = "medium" }) => (
    <div className={`skeleton skeleton-line ${size}`} />
);

export const LeftPanelSkeleton = () => (
    <div className="p-3">
        <div className="skeleton skeleton-cover w-100 mb-3" />
        <div className="d-flex align-items-center mb-3">
            <div className="skeleton skeleton-avatar me-3" />
            <div style={{ flex: 1 }}>
                <SkeletonLine size="medium" />
                <SkeletonLine size="short" />
            </div>
        </div>
        <SkeletonLine size="long" />
        <SkeletonLine size="medium" />
    </div>
);

export const MiniProfileSkeleton = () => (
    <div className="p-3">
        <div className="Profile-img-mini mb-3">
            <div className="skeleton skeleton-avatar" />
        </div>
        <SkeletonLine size="medium" />
        <SkeletonLine size="short" />
    </div>
);

export const TimelineSkeleton = () =>
    Array.from({ length: 3 }).map((_, i) => (
        <div
            key={`skeleton-post-${i}`}
            className="mt-3 bg-white rounded p-3"
            style={{ boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.2)", margin: "1px" }}
        >
            <div className="d-flex mb-3">
                <div className="skeleton skeleton-avatar me-3" />
                <div style={{ flex: 1 }}>
                    <SkeletonLine size="medium" />
                    <SkeletonLine size="short" />
                </div>
            </div>
            <SkeletonLine size="long" />
            <div className="skeleton skeleton-post mt-2" />
        </div>
    ));